import { render, staticRenderFns } from "./DuplicateUsersIDcard.vue?vue&type=template&id=0b7adbd2&"
import script from "./DuplicateUsersIDcard.vue?vue&type=script&lang=js&"
export * from "./DuplicateUsersIDcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports